import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MessageService {
  private subject = new Subject<any>();
  private mbIsLogged = false;
  sendMessage(asMsgName: string, aoParams: any) {
    this.subject.next({ name: asMsgName, params: aoParams });
  }

  clearMessage() {
    this.subject.next();
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  getIslogged(): boolean {
    return this.mbIsLogged;
  }
  setIslogged(abLogged: boolean) {
    this.mbIsLogged = abLogged;
  }
}
